import { CloseOutlined } from "@ant-design/icons";
import React, { type ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { formatTranslation } from "../../../shared/utils/translationUtils";

interface ToolPanelProps {
  title: string;
  icon: ReactNode;
  onClose: () => void;
  children: ReactNode;
  instruction: string;
}

/** Header + content + instruction shell shown while a tool is active. */
const ToolPanel: React.FC<ToolPanelProps> = ({
  title,
  icon,
  onClose,
  children,
  instruction,
}) => {
  const { t } = useTranslation();

  return (
    <div className="tool-panel" data-testid="map-tool-panel">
      <div className="tool-panel-header">
        <span className="tool-panel-title">
          {icon}
          {title}
        </span>
        <button
          type="button"
          className="tool-panel-close"
          onClick={onClose}
          aria-label={formatTranslation(t("newTrial.mapControls.close"))}
          data-testid="map-tool-panel-close"
        >
          <CloseOutlined />
        </button>
      </div>
      <div className="tool-panel-content">{children}</div>
      <div className="tool-panel-instruction">{instruction}</div>
    </div>
  );
};

export default ToolPanel;
